import React, { useEffect, useRef } from 'react';
import { Typography } from 'fronton-react';
import {
	otherServicesStyles,
	otherServicesWrapperStyles,
	otherServicesContainerStyles,
} from './style';
import { Service } from './components/service';
import { services } from './other-services-db';
import { Carousel } from './components/carousel';
import { useInView } from 'common/hooks';
import { GAPromoView } from 'utils';

export const OtherServices = () => {
	const { ref, inView } = useInView<HTMLDivElement>();
	const isAlreadyWatched = useRef(false);

	useEffect(() => {
		if (inView && !isAlreadyWatched.current) {
			isAlreadyWatched.current = true;
			const promotions = services.map((el, index) => ({
				name: 'landingChernovoyRemont_bottom',
				creative: el.name,
				position: `${index + 1}`,
			}));
			GAPromoView({ promotions, elementBlock: 'landingChernovoyRemont' });
		}
	}, [inView]);

	return (
		<div className={otherServicesStyles} ref={ref}>
			<div className={otherServicesWrapperStyles}>
				<Typography variant="h2" as="h2">
					Другие услуги
				</Typography>
				<div className={otherServicesContainerStyles}>
					{services.map((el, index) => (
						<Service {...el} key={el.name} index={index} />
					))}
				</div>
				<Carousel />
			</div>
		</div>
	);
};
